import { useEffect } from 'react';

const useSEO = ({ title, description, keywords, ogTitle, ogDescription, ogImage }) => {
  useEffect(() => {
    // Update document title
    if (title) {
      document.title = title;
    }

    // Update meta description
    if (description) {
      updateMetaTag('name', 'description', description);
    }

    // Update meta keywords
    if (keywords) {
      updateMetaTag('name', 'keywords', keywords);
    }

    // Update Open Graph tags
    if (ogTitle) {
      updateMetaTag('property', 'og:title', ogTitle);
    }

    if (ogDescription) {
      updateMetaTag('property', 'og:description', ogDescription);
    }

    if (ogImage) {
      updateMetaTag('property', 'og:image', ogImage);
    }

    // Update Twitter tags
    if (ogTitle) {
      updateMetaTag('property', 'twitter:title', ogTitle);
    }

    if (ogDescription) {
      updateMetaTag('property', 'twitter:description', ogDescription);
    }

  }, [title, description, keywords, ogTitle, ogDescription, ogImage]);
};

const updateMetaTag = (attribute, name, content) => {
  const metaTag = document.querySelector(`meta[${attribute}="${name}"]`);
  if (metaTag) {
    metaTag.setAttribute('content', content);
  } else {
    const newMetaTag = document.createElement('meta');
    newMetaTag.setAttribute(attribute, name);
    newMetaTag.setAttribute('content', content);
    document.head.appendChild(newMetaTag);
  }
};

export default useSEO;
